<!--列表查看视图-->
<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="title"
      width="800px"
      :close-on-click-modal="false"
      class="app-main-inner"
    >
      <div class="tabs-container  app-main-inner-row" style="flex-grow:1;">
        <el-tabs v-model="activeTabName" type="card" @tab-click="tab_changeHandler">
          <el-tab-pane :key="10" :label="$t('Message.FileInformation')" name="fileInfo">
            <div>
              <cargo-ag-grid
                :grid-options="gridOptions"
                :grid-params.sync="gridParams"
                :column-defs="columnDefs"
                :row-data="rowData"
                :check-sub-record="false"
                style="width:100%;min-width:650px;flex:1;padding:10px;height: 400px;"
                @gridReady="params=>gridApi=params.api"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane :key="20" :label="$t('Message.Thumbnail')" name="thumbnail">
            <div style="width:100%; height: 400px;min-width: 650px;">
              <viewer :images="photoList">
                <img v-for="(item, index) in photoList" :key="index" :src="item.src" height="156" width="120" :title="item.fileName" style="margin:30px;">
              </viewer>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div slot="footer">
        <el-button no="downloadHandler" type="primary" :disabled="!(activeTabName==='fileInfo')" @click="downloadHandler">{{ $t('Message.DownloadPhotos') }}</el-button>
        <el-button no="sendMailHandler" type="primary" :disabled="!(job && job.lob==='AE' && activeTabName==='fileInfo')" @click="sendMailHandler">{{ $t('FileHistory.SendEmail') }}</el-button>
        <el-button v-if="(job && activeTabName ==='fileInfo' && !showUploadFileBtn)" no="uploadFileHistory" type="primary" @click="uploadFileHistory">{{ $t('FileHistory.TransferAllToFileHistory') }}</el-button>
        <el-button no="cancelHandler" @click="cancelHandler">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
      </div>
    </el-dialog>

    <!-- 发送邮件弹窗 -->
    <email-input
      v-if="emailInput.visible"
      :visible.sync="emailInput.visible"
      :job="job"
      source="pictureViewWindow"
      :context="{}"
      :is-copy-link="true"
      :send-email-data="emailInput"
      :send-call-back="sendCallBack"
    />
  </div>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { findBusinessDocument, sendPhotoMail, uploadFileHistory } from '@/api/seaExport/businessDocument'
import emailInput from '@/components/Cargo/Job/emailInput'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'PictureViewWindow',
  components: { emailInput },
  props: {
    visible: { type: Boolean, required: true },
    model: { type: Object, required: true },
    title: { type: String, required: true, default: '' },
    fileName: { type: String, required: true, default: '' },
    type: { type: String, required: true, default: '' },
    job: { type: Object, required: true }
  },
  data: function() {
    return {
      innerVisible: false,
      storageURL: '',
      emailInput: {
        visible: false,
        emailTitle: '',
        emailContent: '',
        detailCode: '',
        fileIdList: ''
      },
      documentManage: new DocumentManage(),
      showUploadFileBtn: false,
      loading: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FileHistory.fileName'),
          field: 'fileName',
          width: 120,
          cellRenderer: params => {
            if (!params || !params.data || !params.data.fileId) return
            const methodPath = this.documentManage.getPath('downloadDoc')
            return `<a onclick="${methodPath}('${params.data.fileId}')" style="color:blue;text-decoration: underline;">${params.data.fileName}</a>`
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileType'),
          field: 'fileType',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FileSize'),
          field: 'fileSize',
          width: 120,
          cellRenderer: (params) => {
            if (!params || !params.data) return
            return ColumnUtils.fileSizeLabelFun(params.data.fileSize)
          }
        },
        {
          headerName: this.$t('Partners.UploadTime'),
          field: 'dateCreated',
          width: 120,
          cellRenderer: (params) => {
            if (!params || !params.data) return
            return ColumnUtils.dateLabelFunc(params.data.dateCreated)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      activeTabName: 'fileInfo',
      photoList: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
        const config = cache.config
        this.showUploadFileBtn = Number(config.get('warehouseInPhoneUpload')) === 1
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
        this.documentManage.destory()
      }
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('downloadDoc', function(fileId) {
      context.downloadDoc(fileId)
    })
  },
  created() {
    if (this.visible) {
      this.toQuery()
    }
  },
  methods: {
    async toQuery() {
      await cache.load(cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
      this.activeTabName = LocalStorageUtils.getConfiguration('picViewIndex')
      if (!this.activeTabName) this.activeTabName = 'fileInfo'
      this.toQueryFiles()
    },
    tab_changeHandler() {
      this.photoList = []
      LocalStorageUtils.setConfiguration('picViewIndex', this.activeTabName)
      this.toQuery()
    },
    // 查询进仓文件
    async toQueryFiles() {
      if (this.model && this.model.uuid) {
        let res = null
        if (this.model.businessDocument) {
          res = { data: this.model.businessDocument }
        } else if (this.type === 'WarehouseOut') {
          res = await findBusinessDocument({ warehouseOutUuid: this.model.uuid })
        } else {
          res = await findBusinessDocument({ warehouseInUuid: this.model.uuid })
        }
        if (this.type === 'WarehouseOut') {
          this.rowData = Array.from(res.data, p => {
            return {
              uuid: p.uuid,
              fileId: p.documentId,
              fileName: p.fileName,
              fileType: p.fileType || '',
              fileSize: p.fileSize,
              dateCreated: p.dateCreated,
              documentId: p.documentId,
              warehouseOutUuid: p.warehouseOutUuid
            }
          })
        } else {
          this.rowData = Array.from(res.data, p => {
            return {
              uuid: p.uuid,
              fileId: p.documentId,
              fileName: p.fileName,
              fileType: p.fileType || '',
              fileSize: p.fileSize,
              dateCreated: p.dateCreated,
              documentId: p.documentId,
              warehouseInUuid: p.warehouseInUuid
            }
          })
        }
        if (!this.rowData || this.rowData.length <= 0) return
        this.toQueryPhotos()
      }
    },
    // 查询缩略图文件
    toQueryPhotos() {
      this.photoList = []
      if (!this.rowData || this.rowData.length <= 0) return
      const docs = this.filterImages(this.rowData)
      if (!docs || docs.length <= 0) return
      for (const doc of docs) {
        doc.src = `${URL.common.findByFileId}/${doc.fileId}?sessionId=${this.$store.getters.token}`
        this.photoList.push(doc)
      }
    },
    // 过滤图片
    filterImages(docs) {
      const images = []
      const IMAGES = ['JPG', 'PNG', 'JPEG', 'GIF', 'BMP']
      for (const doc of docs) {
        if (!doc.fileType || !IMAGES.includes(doc.fileType.toUpperCase())) continue
        images.push(doc)
      }
      return images
    },
    // 获取选中行
    readSelectedRows(isTip = true) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0 && isTip) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 下载进仓文件
    downloadHandler() {
      if (!this.validate()) return
      const rows = this.readSelectedRows()
      if (!rows || rows.length <= 0) return
      const fileIds = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
      const fileName = this.fileName
      window.open(`${URL.common.compressFiles}?sessionId=${this.$store.getters.token}&fileIds=${fileIds}&fileName=${fileName}`)
    },
    sendMailHandler() {
      if (!this.validate()) return
      const rows = this.readSelectedRows(false)
      const r = this.getDefaultMail()
      this.emailInput.emailTitle = r[0]
      this.emailInput.emailContent = r[1]
      this.emailInput.fileIdList = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
      this.emailInput.visible = true
    },
    async uploadFileHistory() {
      if (this.model != null && this.model.uuid && this.model.jobKey) {
        const object = {}
        object.warehouseInUuid = this.model.uuid
        object.jobUuid = this.model.jobKey
        this.loading = getLoading()
        await uploadFileHistory(object).then(res => {
          const str = res.data
          if (str) {
            this.$message.success(this.$t('Message.UploadComplete'))
          } else {
            this.$message.error(this.$t('Message.UploadFailedSigh'))
          }
        }).finally((e) => {
          this.loading.close()
        })
      }
    },
    getDefaultMail() {
      let title = ''
      let content = `${this.$t('Message.Hello')},\n\n${this.$t('Message.EnclosedPleaseFind')}`

      if (this.type === 'AirExportFlightCustomer') {
        // title = "装板照片";
        // content += this.$t('Message.WaybillNo');
        // var mbls:Array = [];
        // for each (var job:AirExportJob in AirExportFlightCustomer(model).airExportJob)
        // {
        //   if (job.mbl && job.mbl.length > 0)
        //     mbls.push(job.mbl);
        // }
        // if (mbls.length > 0)
        // {
        //   title += "-"+ mbls.join(",");
        //   content += mbls.join(",");
        // }
      } else if (this.type === 'WarehouseIn') {
        title = this.$t('Message.WarehousingNo') + this.model.warehouseNo
        content += this.$t('Message.WarehousingNoColon') + this.model.warehouseNo
      } else {
        title = this.$t('Message.WarehousingNo') + this.replaceN(this.job.warehouseNo)
        content += this.$t('Message.WarehousingNoColon') + this.replaceN(this.job.warehouseNo)
      }

      content += `${this.$t('Message.PhotosOf')}\n\n${this.$t('Message.ThankYou')}\n\n` + this.$store.getters.userInfo.email
      return [title, content]
    },
    replaceN(s) {
      if (!s) return ''
      return s.replace(/\n/g, '')
    },
    async sendCallBack(title, to, cc, content, pushLink) {
      const rows = this.readSelectedRows(true)
      if (!rows || rows.length <= 0) return
      const fileIds = Array.from(rows, p => p.fileId)
      const fileIdStr = fileIds.join(',')
      const item = {}
      item.to = to || ''
      item.cc = cc || ''
      // item.pushLink = pushLink || ''
      item.title = title || ''
      item.content = content || ''
      item.fileIdStr = fileIdStr || ''
      await sendPhotoMail(item).then(res => {
        const str = res.data
        if (str === 'success') {
          this.$message.success(this.$t('Message.SendingSucceeded'))
        } else {
          this.$message.success(this.$t('Message.SendingFailed'))
        }
      }).finally(() => {
        this.emailInput.visible = false
      })
    },
    validate() {
      const docs = this.readSelectedRows(false)
      if (!docs || docs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseTheFileToDownload'))
        return false
      }
      return true
    },
    // 点击文件名下载进仓文件
    downloadDoc(fileId) {
      if (!fileId) return
      const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
      window.open(url)
    },
    cancelHandler() {
      this.innerVisible = false
      this.photoList = []
    }
  }
}
</script>
